import { FormlyFieldConfig } from "@ngx-formly/core";
import { WidgetsAbstract } from "./widgets/widgets.abstract";

export abstract class AbstractRender {
    abstract render(
        widget: WidgetsAbstract,
        config: FormlyFieldConfig[],
        widgetRoot: WidgetsAbstract,
        formlyRoot: FormlyFieldConfig,
        isInsideQuestion: boolean,
        isRecursive: boolean
      );
}
